import { forwardRef, useRef, useImperativeHandle } from 'react';
import cn from 'bem-cn';

import { ValidationWrapper } from '../ValidationWrapper/ValidationWrapper';
import { useHighlightPlaceholders } from '../../../hooks';
import { HighlightedTextAreaProps } from './HighlightedTextArea.types';
import { useScrollSync } from './HighlightedTextArea.hooks';

import './HighlightedTextArea.scss';

const b = cn('highlighted-textarea');

export const HighlightedTextArea = forwardRef<HTMLTextAreaElement, HighlightedTextAreaProps>(
    ({ className, error, value = '', disabled = false, ...props }, ref) => {
        const textareaRef = useRef<HTMLTextAreaElement>(null);
        const overlayRef = useRef<HTMLDivElement>(null);

        // Применяем подсветку к overlay элементу
        useHighlightPlaceholders(overlayRef, String(value));

        // Синхронизируем скролл между textarea и overlay
        useScrollSync(textareaRef, overlayRef);

        // Высота синхронизируется автоматически через CSS (position: absolute с top/bottom)

        // Пробрасываем ref наружу
        useImperativeHandle(ref, () => textareaRef.current as HTMLTextAreaElement);

        return (
            <ValidationWrapper error={error}>
                <div className={b({ error: Boolean(error), disabled })}>
                    <div className={b('wrapper')}>
                        <div className={b('overlay')} ref={overlayRef}>
                            {value || ''}
                        </div>
                        <textarea
                            ref={textareaRef}
                            className={b('textarea', { error: Boolean(error), disabled })}
                            value={value}
                            disabled={disabled}
                            {...props}
                        />
                    </div>
                </div>
            </ValidationWrapper>
        );
    },
);
